module.exports = __webpack_public_path__ + "static/media/services.f39320c1.webp";